module.exports = __webpack_public_path__ + "img/place24.08c1b7f3.jpg";